var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5126_9868)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5126_9868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3833 14.991L5.34361 14.4926C5.28669 14.4971 5.26883 14.4985 5.25488 14.4992C5.24413 14.4998 5.23562 14.4999 5.19675 14.5003C4.83205 14.4997 4.48243 14.3545 4.22773 14.0985L4.22679 14.0975L0.904147 10.7749L0.903694 10.7744C0.365677 10.2378 0.365455 9.36668 0.902911 8.82922C1.43962 8.29252 2.31065 8.29252 2.84735 8.82922L4.59594 10.5778L5.01604 10.9979L5.35823 10.5122L11.9997 1.08571L12.0003 1.08483C12.4369 0.462304 13.296 0.313254 13.9175 0.751744L13.9176 0.751776C14.5379 1.18933 14.6867 2.04714 14.2496 2.66707L14.2495 2.66723L6.3244 13.9157L6.324 13.9163C6.08714 14.2535 5.71525 14.4625 5.34293 14.4927L5.3833 14.991ZM5.3833 14.991C5.90855 14.9485 6.41361 14.6586 6.73314 14.2037L3.87324 14.4511C4.22314 14.8029 4.70162 15.0003 5.19901 15.0003C5.27632 14.9996 5.27633 14.9996 5.38325 14.991L5.3833 14.991Z",
    fill: "white",
    stroke: "#1F1F1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5126_9868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5126_9868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5c055caee6864b42c5daadeb03d4c0bd.svg";
export { ForwardRef as ReactComponent };